// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3C6nD","rootNoMargin":"styles_rootNoMargin__3DC7c"};